import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import CommonService from "../../services/common.service";
import Loader from "../Common/Loader";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
import IndoorGameTotalBlock from "./IndoorGameTotalBlock";
import CommonTotalBlock from "./CommonTotalBlock";
const GameChart = () => {
  useAutoAddQueryString();
  const [data, setData] = useState([]);
  const [teamCount, setTeamCount] = useState([]);
  const [teamCountTotal, setTeamCountTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isGameBarLoading, setIsGameBarLoading] = useState(true);
  const [labelNames, setLabelNames] = useState([]);
  const [gameView, setGameView] = useState([]);
  const [tradeCount, setTradeCount] = useState([]);
  const [gameInfoData, setGameInfoData] = useState({});

  // GameBar variable here
  const [runsRangeData, setRunwRangeData] = useState([]);
  const [wksRangeData, setWksRangeData] = useState([]);
  const [foursRangeData, setFoursRangeData] = useState([]);
  const [sixesData, setSixesData] = useState([]);
  const [mdnsData, setMdnsData] = useState([]);
  const [fpsData, setFpsData] = useState([]);

  const [csRangeData, setCsRangeData] = useState([]);
  const [cwksRangeData, setCwksRangeData] = useState([]);
  const [stsRangeData, setStsRangeData] = useState([]);
  const [rodsRangeData, setRodsRangeData] = useState([]);
  const [roasRangeData, setRoasRangeData] = useState([]);
  const [dksRangeData, setDksRangeData] = useState([]);
  const [noRangeData, setNoRangeData] = useState([]);
  const [hattrickRangeData, setHattrickRangeData] = useState([]);

  const [fantasyPointsData, setFantasyPointsData] = useState({});
  const [gameDetails, setGameDetails] = useState({});
  useEffect(() => {
    CommonService.gameChart()
      .then((res) => {
        if (res.success) {
          setData(res.data);
          setTeamCount(res.teamCounts);
          setTeamCountTotal(res.totalCount);
          setLabelNames(res.labels);
          setGameView(res.roundGameViewCounts);
          setTradeCount(res.tradeCountData);
          setGameInfoData(res.gameInfoBlockData);
          setIsLoading(false);
        }
      })
      .then(() => {
        CommonService.getGameBarGraph().then((res) => {
          if (res.success) {
            setRunwRangeData(res.data);
            setWksRangeData(res.wksRangeData);
            setFoursRangeData(res.foursRangeData);
            setSixesData(res.sixesRangeData);
            setMdnsData(res.mdnsRangeData);
            setFpsData(res.fpRangeData);

            setCsRangeData(res.csRangeData);
            setCwksRangeData(res.cwksRangeData);
            setStsRangeData(res.stsRangeData);
            setRodsRangeData(res.rodsRangeData);
            setRoasRangeData(res.roasRangeData);
            setDksRangeData(res.dksRangeData);
            setNoRangeData(res.noRangeData);
            setHattrickRangeData(res.hattrickRangeData);

            setIsGameBarLoading(false);
          }
        });
      })
      .then(() => {
        CommonService.getFantasyScoreTotal().then((res) => {
          if (res.success) {
            setFantasyPointsData(res.data);
            setGameDetails(res.gameDetails);
          }
        });
      });
  }, []);

  // Game Bar chart logic start here

  const dataRunsValues = runsRangeData
    ? Object.values(runsRangeData).map((value) => parseInt(value, 10))
    : [];

  const dataWksValues = wksRangeData
    ? Object.values(wksRangeData).map((value) => parseInt(value, 10))
    : [];

  const dataFoursValues = foursRangeData
    ? Object.values(foursRangeData).map((value) => parseInt(value, 10))
    : [];

  const dataSixesValues = sixesData
    ? Object.values(sixesData).map((value) => parseInt(value, 10))
    : [];

  const dataMdnsValues = mdnsData
    ? Object.values(mdnsData).map((value) => parseInt(value, 10))
    : [];

  const dataFpValues = fpsData
    ? Object.values(fpsData).map((value) => parseInt(value, 10))
    : [];

  const dataCsValues = csRangeData
    ? Object.values(csRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataCwksValues = cwksRangeData
    ? Object.values(cwksRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataStsValues = stsRangeData
    ? Object.values(stsRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataRodsValues = rodsRangeData
    ? Object.values(rodsRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataRoasValues = roasRangeData
    ? Object.values(roasRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataDksValues = dksRangeData
    ? Object.values(dksRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataNoValues = noRangeData
    ? Object.values(noRangeData).map((value) => parseInt(value, 10))
    : [];
  const dataHattrickValues = hattrickRangeData
    ? Object.values(hattrickRangeData).map((value) => parseInt(value, 10))
    : [];

  const formatteRunsdData = {
    series: [
      {
        name: "Runs Per Inning",
        data: dataRunsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-9",
          "10-29",
          "30-49",
          "50-69",
          "70-89",
          "90-99",
          "100-149",
          "150-199",
          "200+",
        ],
      },
      title: {
        text: "Runs Per Inning",
        align: "left",
      },
    },
  };

  const formattedWksData = {
    series: [
      {
        name: "Wickets Per Inning",
        data: dataWksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Wickets Per Inning",
        align: "left",
      },
    },
  };

  const formattedFourData = {
    series: [
      {
        name: "Fours Per Inning",
        data: dataFoursValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-2",
          "3-4",
          "5-6",
          "7-8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Fours Per Inning",
        align: "left",
      },
    },
  };
  const formattedSixesData = {
    series: [
      {
        name: "Sixes Per Inning",
        data: dataSixesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8-9", "21+"],
      },
      title: {
        text: "Sixes Per Inning",
        align: "left",
      },
    },
  };
  const formattedMdnsData = {
    series: [
      {
        name: "Maidens Per Inning",
        data: dataMdnsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-2",
          "3-4",
          "5-6",
          "7-8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Maidens Per Inning",
        align: "left",
      },
    },
  };
  const formattedFpData = {
    series: [
      {
        name: "Fantasy Points Per Inning",
        data: dataFpValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-50",
          "51-100",
          "101-150",
          "151-200",
          "201-300",
          "301-400",
          "401-500",
          "501+",
        ],
      },
      title: {
        text: "Fantasy Points Per Inning",
        align: "left",
      },
    },
  };

  const formattedCsData = {
    series: [
      {
        name: "Catches Per Inning",
        data: dataCsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Catches Per Inning",
        align: "left",
      },
    },
  };
  const formattedCwksData = {
    series: [
      {
        name: "Catches (Wicket-Keeper) Per Inning",
        data: dataCwksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Catches (Wicket-Keeper) Per Inning",
        align: "left",
      },
    },
  };
  const formattedStsData = {
    series: [
      {
        name: "Stumpings Per Inning",
        data: dataStsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Stumpings Per Inning",
        align: "left",
      },
    },
  };
  const formattedRodsData = {
    series: [
      {
        name: "Run-Out Direct Per Inning",
        data: dataRodsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Run-Out Direct Per Inning",
        align: "left",
      },
    },
  };
  const formattedRoasData = {
    series: [
      {
        name: "Run-Out Assisted Per Inning",
        data: dataRoasValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Run-Out Assisted Per Inning",
        align: "left",
      },
    },
  };
  const formattedDksData = {
    series: [
      {
        name: "Duck Per Inning",
        data: dataDksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Duck Per Inning",
        align: "left",
      },
    },
  };
  const formattedNoData = {
    series: [
      {
        name: "Not Out Per Inning",
        data: dataNoValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Not Out Per Inning",
        align: "left",
      },
    },
  };
  const formattedHattrickData = {
    series: [
      {
        name: "Hat-Trick Per Inning",
        data: dataHattrickValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Hat-Trick Per Inning",
        align: "left",
      },
    },
  };
  // Game Bar chart logic start here

  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  const chartData = {
    series: [data?.batCount, data?.bowlCount, data?.arCount, data?.wkCount],
  };

  const chartOptions = {
    labels: ["BAT", "BOWL", "AR", "WK"],
    colors: ["#4BC0C0", "#36A2EB", "#FFCE56"],
    title: {
      text: "Player Types",
      align: "left",
    },
  };

  //   Fixture per team graph start here

  const teamData = teamCount.map((team) => {
    const percentage = ((team.team_count / teamCountTotal) * 100).toFixed(2);
    return {
      name: team.team_name,
      data: team.team_count,
      percentage: percentage,
      color: getRandomColor(), // Assuming you have a function to generate random colors
    };
  });

  const chartData1 = {
    series: teamData.map((team) => team.data),
  };

  const chartOptions1 = {
    labels: teamData.map((team) => `${team.name} (${team.percentage}%)`),
    colors: teamData.map((team) => team.color),
    title: {
      text: "Fixtures Per Team",
      align: "left",
    },
  };
  //   Fixture per team graph finish here

  //   Player Used graph start here
  const chartData2 = {
    series: [data?.playerInUse, data?.playerNotInUse],
  };

  const chartOptions2 = {
    labels: [`Yes (${data?.inUsePercent}%)`, `No (${data?.notInUsePercent}%)`],
    colors: ["#4BC0C0", "#36A2EB"],
    title: {
      text: "Player Used",
      align: "left",
    },
  };
  //   Player Used graph finish here

  //   Team Picked graph start here
  const chartData3 = {
    series: [data?.membersWithTeamCount, data?.membersWithoutTeamCount],
  };

  const chartOptions3 = {
    labels: [
      `Picked Team (${data?.membersWithTeamPercent}%)`,
      `Not Picked Team (${data?.membersWithoutPercent}%)`,
    ],
    colors: ["#4BC0C0", "#36A2EB"],
    title: {
      text: "Team Selection",
      align: "left",
    },
  };
  //   Team Picked graph finish here

  // Gameviews and trades count

  const labelNamesOptions = Object.keys(labelNames);
  const gameViewData = Object.values(gameView).map((value) =>
    parseFloat(value, 10)
  );
  const tradeCountData = Object.values(tradeCount).map((value) =>
    parseFloat(value, 10)
  );

  const formattedGameViewData = {
    series: [
      {
        name: "Gameviews",
        data: gameViewData,
      },
    ],
  };

  const gameViewOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesOptions,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Gameviews",
      align: "left",
    },
  };

  const formattedTradeCountData = {
    series: [
      {
        name: "Trades",
        data: tradeCountData,
      },
    ],
  };

  const tradeCountOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesOptions,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Trades",
      align: "left",
    },
  };
  // Gameviews and trades count

  const clubDetails = JSON.parse(localStorage.getItem("club_details"));

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container-fluid">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Game Charts</h2>
            </div>
            <div className="countdata mt-4 mb-4">
              <div className="gameweek-filter">
                <h4>{clubDetails?.game_name}</h4>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.teamEntered}</strong>
                      <span>Teams Entered</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.totalPlayer}</strong>
                      <span>Players Added</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.trade_used}</strong>
                      <span>Trades Used</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.player_profile_views}</strong>
                      <span>Player Views</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameInfoData?.gameViews}</strong>
                      <span>Gameviews</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="countdata mt-4 mb-4">
              <div className="gameweek-filter">
                <h4>Total Numbers</h4>
              </div>

              {gameDetails?.game_type === 3 && (
                <IndoorGameTotalBlock fantasyPointsData={fantasyPointsData} />
              )}
              {gameDetails?.game_type !== 3 && (
                <CommonTotalBlock fantasyPointsData={fantasyPointsData} />
              )}

              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_wks}</strong>
                      <span> Wickets</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_cs}</strong>
                      <span> Catches</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_cwks}</strong>
                      <span> Catches (WK)</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_sts}</strong>
                      <span>Stumpings</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_roas}</strong>
                      <span> Run-Out (A)</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_rods}</strong>
                      <span> Run-Out (D)</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_hattrick}</strong>
                      <span> Hat-Tricks</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_dks}</strong>
                      <span> Ducks</span>
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{fantasyPointsData?.sum_fp?.toFixed(2)}</strong>
                      <span>Fantasy Points</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row pb-3">
              <div className="col-md-6 col-sm-12">
                <div className="tab-content">
                  <Chart
                    options={gameViewOptions}
                    series={formattedGameViewData.series}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="tab-content">
                  <Chart
                    options={tradeCountOptions}
                    series={formattedTradeCountData.series}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
            </div>

            <ul className="sponsor_list bonus-card  chart-strech">
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions}
                    series={chartData.series}
                    type="pie"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions1}
                    series={chartData1.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions2}
                    series={chartData2.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={chartOptions3}
                    series={chartData3.series}
                    type="donut"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formatteRunsdData.chartOptions}
                    series={formatteRunsdData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedWksData.chartOptions}
                    series={formattedWksData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedFourData.chartOptions}
                    series={formattedFourData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedSixesData.chartOptions}
                    series={formattedSixesData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedMdnsData.chartOptions}
                    series={formattedMdnsData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedFpData.chartOptions}
                    series={formattedFpData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>

              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedCsData.chartOptions}
                    series={formattedCsData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedCwksData.chartOptions}
                    series={formattedCwksData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedStsData.chartOptions}
                    series={formattedStsData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedRodsData.chartOptions}
                    series={formattedRodsData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedRoasData.chartOptions}
                    series={formattedRoasData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedDksData.chartOptions}
                    series={formattedDksData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedNoData.chartOptions}
                    series={formattedNoData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
              <li>
                <div className="sponsorslide">
                  <Chart
                    options={formattedHattrickData.chartOptions}
                    series={formattedHattrickData.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameChart;
